module.exports = __webpack_public_path__ + "../resources/img/ic_check.eb7c1008.svg";